import React from "react";
import { CheckCircle2Icon, InfoIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { volumes } from "../data/content";
export function Volumes() {
  return <section className="bg-white px-4 py-16 sm:px-6 sm:py-20" data-id="element-299" data-mp="185gf4d0siesd">
      <div className="mx-auto max-w-4xl" data-id="element-300" data-mp="1c4p65a4g3yk8">
        <SectionHeading kicker="What's inside the Blueprint™" title="Six Professional Volumes Designed to Work Together" subtitle="Each volume addresses a different stage of the investigation, from identifying the problem to documenting the results—so you move through a case with a clear process instead of scattered notes and improvised decisions." data-id="element-301" data-mp="1c5qgfcdn0h0w" />

        <div className="mt-10 space-y-6" data-id="element-302" data-mp="1vrwlpb9br9zw">
          {volumes.map(v => <article key={v.number} className="overflow-hidden rounded-3xl border border-ink/10 bg-white shadow-sm" data-id="element-303" data-mp="fe6ehvmws5m1">
              <div className="flex items-center gap-4 px-5 py-4 text-white sm:px-8" style={{
            backgroundColor: v.color
          }} data-id="element-304" data-mp="kfvrhgtoytcr">
                <span className="font-display text-sm font-extrabold uppercase tracking-widest text-white/90" data-id="element-305" data-mp="3oa9dz0l87tff">
                  Volume
                </span>
                <span className="font-display text-3xl font-black leading-none" data-id="element-306" data-mp="2201u60bpm7h">{v.number}</span>
              </div>
              <div className="p-5 sm:p-8" data-id="element-307" data-mp="3t5oobik0z773">
                <h3 className="font-display text-[22px] font-extrabold leading-tight text-ink sm:text-2xl" data-id="element-308" data-mp="b1da4vcpo4qm">{v.title}</h3>
                <p className="mt-3 text-[16px] leading-relaxed text-ink-soft" data-id="element-309" data-mp="63bsmeuxodh9">{v.intro}</p>
                <p className="mt-5 text-sm font-bold uppercase tracking-wide text-ink" data-id="element-310" data-mp="krzhy3e6rqyr">Inside, you'll find:</p>
                <ul className="mt-3 space-y-2.5" data-id="element-311" data-mp="fs3fi8l507lb">
                  {v.items.map(item => <li key={item} className="flex gap-3 text-[16px] leading-snug text-ink" data-id="element-312" data-mp="trcw39d993pt">
                      <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0" style={{
                  color: v.color
                }} aria-hidden="true" data-id="element-313" data-mp="pr2mznu61x6q" />
                      <span data-id="element-314" data-mp="wv25wvtoy6os">{item}</span>
                    </li>)}
                </ul>
                <p className="mt-6 rounded-xl bg-canvas px-4 py-3 text-[16px] leading-snug text-ink" data-id="element-315" data-mp="11tlruw8abih5">
                  <strong data-id="element-316" data-mp="16qcanrbh4s69">The result:</strong> {v.result}
                </p>
                {v.note && <p className="mt-3 flex gap-2 text-xs leading-relaxed text-ink-muted" data-id="element-317" data-mp="1bjycspk0hdnt">
                    <InfoIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-318" data-mp="1fjp9tb04sq0s" />
                    {v.note}
                  </p>}
              </div>
            </article>)}
        </div>

        <div className="mt-10" data-id="element-319" data-mp="1pgbtvxkmvd1r">
          <CtaButton label="Yes! I want all six volumes" arrow data-id="element-320" data-mp="1uh7wm7t90t5l" />
        </div>
      </div>
    </section>;
}